import { useQuery, useQueryClient } from "@tanstack/react-query";
import { __PostJsonData } from "request/Petitions/__Post";
import { __GetExtractTreasury } from "request/Inventory/__InventoryCRUD";
import environment from "constants/apiConst";

// Hook para obtener datos de extractos
export const useExtracts = (token, page = 1, enabled = true) => {
  return useQuery({
    queryKey: ["extracts", page],
    queryFn: async () => {
      const res = await __GetExtractTreasury(token, page);
      const requestExtract = res?.data?.status?.data?.data;

      return {
        data: requestExtract || [],
        lastPage: res?.data?.status?.data?.last_page || 1,
        total: res?.data?.status?.data?.total || 0
      };
    },
    enabled: enabled && !!token,
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos
    refetchOnWindowFocus: false,
    retry: 2,
    retryDelay: 1000
  });
};

// Hook para búsqueda de extractos usando useQuery
export const useExtractsSearch = (token, searchData, page = 1, enabled = false) => {
  return useQuery({
    queryKey: ["extractsSearch", searchData, page],
    queryFn: async () => {
      if (!searchData || Object.keys(searchData).length === 0) {
        throw new Error("No hay datos de búsqueda");
      }

      const res = await __PostJsonData(
        environment.TREASURY_EXPORT_GET,
        token,
        searchData,
        page
      );

      if (res?.data?.status?.message === "Acceso no autorizado.") {
        throw new Error("Acceso no autorizado.");
      }

      return {
        data: res?.data?.status?.data?.data || [],
        lastPage: res?.data?.status?.data?.last_page || 1,
        total: res?.data?.status?.data?.total || 0,
        message: res?.data?.status?.message
      };
    },
    enabled: enabled && !!token && !!searchData && Object.keys(searchData).length > 0,
    staleTime: 2 * 60 * 1000, // 2 minutos para búsquedas
    gcTime: 5 * 60 * 1000, // 5 minutos
    refetchOnWindowFocus: false,
    retry: 1, // Menos reintentos para búsquedas
    retryDelay: 1000
  });
};

// Hook para invalidar cache cuando sea necesario
export const useInvalidateExtracts = () => {
  const queryClient = useQueryClient();

  const invalidateAll = () => {
    queryClient.invalidateQueries({ queryKey: ["extracts"] });
  };

  const invalidatePage = (page) => {
    queryClient.invalidateQueries({ queryKey: ["extracts", page] });
  };

  const removeAll = () => {
    queryClient.removeQueries({ queryKey: ["extracts"] });
  };

  return {
    invalidateAll,
    invalidatePage,
    removeAll
  };
};
